function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Page-1_20_"
}, /*#__PURE__*/React.createElement("g", {
  id: "_x30_21---Red-Yellow-Card",
  transform: "translate(-1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape_35_",
  d: "m178.513 602.503c6.875 3.607 14.908 4.309 22.304 1.949l274.252-85.713c7.251-2.229 13.336-7.219 16.943-13.893h54.23c16.729 0 30.291-13.562 30.291-30.291v-444.264c.001-16.729-13.561-30.291-30.29-30.291h-292.81c-16.729 0-30.291 13.562-30.291 30.291v44.073l-171.224 53.584c-7.443 2.257-13.671 7.404-17.29 14.288-3.619 6.885-4.327 14.933-1.965 22.343l131.462 420.718c2.289 7.436 7.475 13.637 14.388 17.206zm64.822-572.212c0-5.576 4.521-10.097 10.097-10.097h292.81c5.576 0 10.097 4.521 10.097 10.097v444.264c0 5.576-4.521 10.097-10.097 10.097h-59.037c-1.333-.272-2.706-.272-4.039 0h-229.734c-5.576 0-10.097-4.521-10.097-10.097zm-190.831 121.304c1.111-2.109 3.032-3.676 5.321-4.342l165.317-51.726v379.028c0 16.729 13.562 30.291 30.291 30.291h198.414l-257.118 80.351c-2.287.721-4.767.502-6.892-.608s-3.722-3.02-4.437-5.309l-131.482-420.759c-.756-2.292-.544-4.793.586-6.926z"
}), /*#__PURE__*/React.createElement("g", {
  clipRule: "evenodd",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_17_",
  d: "m127.584 146.587-43.417 13.58c-5.319 1.668-8.279 7.332-6.613 12.651l13.318 42.68c1.673 5.325 7.346 8.286 12.672 6.613 5.325-1.673 8.286-7.346 6.613-12.672l-10.309-33.007 33.774-10.571c5.323-1.673 8.281-7.344 6.608-12.667s-7.344-8.281-12.667-6.608h.021z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16_",
  d: "m273.626 100.969c5.576 0 10.097-4.521 10.097-10.097v-30.291h30.291c5.576 0 10.097-4.521 10.097-10.097s-4.521-10.097-10.097-10.097h-40.388c-5.576 0-10.097 4.521-10.097 10.097v40.388c0 5.577 4.521 10.097 10.097 10.097z"
})))));

var SvgMultiple = function SvgMultiple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 605.825 605.825",
    fill: "#000",
    height: 512,
    viewBox: "0 0 605.825 605.825",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultiple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multiple.98fe9875.svg";
export { ForwardRef as ReactComponent };